import {
   Drawer,
   DrawerBody,
   DrawerFooter,
   DrawerHeader,
   DrawerOverlay,
   DrawerContent,
   DrawerCloseButton,
   Button,
   VStack,
   Text,
   Box,
   IconButton,
   useDisclosure,
} from '@chakra-ui/react';
import { HamburgerIcon } from '@chakra-ui/icons';

export const ElementSelectorDrawer = ({ elements, onElementSelect, selectedElement }) => {
   const { isOpen, onOpen, onClose } = useDisclosure();

   const handleElementSelect = (element) => {
      onElementSelect(element);
      onClose(); // Close drawer after selection
   };

   const getElementDisplayName = (element) => {
      // Create a readable name for each element type
      switch (element.type) {
         case 'text':
            return `Text: ${element.content?.substring(0, 30)}${element.content?.length > 30 ? '...' : ''}`;
         case 'line':
            return `Line: ${element.isVertical ? 'Vertical' : 'Horizontal'}`;
         case 'table':
            return `Table: ${element.rows}x${element.columns}`;
         case 'image':
            return `Image: ${element.src ? 'Loaded' : 'Empty'}`;
         default:
            return `${element.type}: ${element.id}`;
      }
   };

   return (
      <>
         <IconButton
            icon={<HamburgerIcon />}
            aria-label="Open element selector"
            onClick={onOpen}
            position="absolute"
            top={4}
            right={4}
            zIndex={10}
            colorScheme="blue"
            size="md"
         />

         <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="md">
            <DrawerOverlay />
            <DrawerContent>
               <DrawerCloseButton />
               <DrawerHeader>
                  <Text fontSize="lg" fontWeight="bold">
                     Select Element
                  </Text>
               </DrawerHeader>

               <DrawerBody>
                  <VStack spacing={3} align="stretch">
                     {elements?.elements?.map((element) => (
                        <Button
                           key={element.id}
                           onClick={() => handleElementSelect(element)}
                           variant={selectedElement?.id === element.id ? 'solid' : 'outline'}
                           colorScheme={selectedElement?.id === element.id ? 'blue' : 'gray'}
                           size="md"
                           textAlign="left"
                           justifyContent="flex-start"
                           p={4}
                           h="auto"
                           whiteSpace="normal">
                           <Box>
                              <Text fontWeight="semibold" fontSize="sm">
                                 ID: {element.id}
                              </Text>
                              <Text fontWeight="semibold" fontSize="sm">
                                 Type: {element.type}
                              </Text>
                              <Text fontSize="sm" mt={1}>
                                 {getElementDisplayName(element)}
                              </Text>
                           </Box>
                        </Button>
                     ))}

                     {(!elements?.elements || elements.elements.length === 0) && (
                        <Text color="gray.500" textAlign="center" py={8}>
                           No elements found
                        </Text>
                     )}
                  </VStack>
               </DrawerBody>

               <DrawerFooter>
                  <Button variant="outline" mr={3} onClick={onClose}>
                     Close
                  </Button>
               </DrawerFooter>
            </DrawerContent>
         </Drawer>
      </>
   );
};
